"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommonSlotProps = void 0;
const getCommonSlotProps = (variant, customInputProps, customHtmlInputProps) => ({
  input: {
    sx: {
      // By default outline variant has minHeight: 32px but for some unknown reason it is not applied in modal hence need to explicitly set it here
      minHeight: variant === 'standard' ? '32px' : undefined
    },
    ...customInputProps
  },
  htmlInput: customHtmlInputProps
});
exports.getCommonSlotProps = getCommonSlotProps;
//# sourceMappingURL=getCommonSlotProps.js.map